import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.saveStyles('.js-schema-line, .js-about-image-wrapper, .js-claim, .js-pr-star, .js-info-block, .js-achievement, .js-achievement-divider, .js-case-image, .js-performance-line, .js-intro-block-image, .js-main-hero-bg, .js-main-hero-line, .js-main-hero-content-slider, .js-schema-block');

ScrollTrigger.matchMedia({
  '(min-width: 1248px)': () => {
    $('.js-about-image').length && gsap.timeline({
      scrollTrigger: {
        trigger: '.js-about-image',
        start: 'top center',
        end: 'center+=100px center',
        scrub: true
      }
    })
      .to('.js-claim',{
        x: '-40vw',
        onReverseComplete() {
          $('.js-claim').css('transform', 'none');
        }}, 0)
      .to('.js-about-image-wrapper', {width: '85%'}, 0)
      .to('.js-about-image-text-left', {width: 400}, 0)
      .to('.js-about-image-text-right', {width: 400}, 0)
    ;
  },
  '(min-width: 960px)': () => {
    const tl = gsap.timeline();

    $('.js-main-hero').length && tl
      .to(['.js-main-hero-content-slider', '.js-main-hero-line'], {y: 300, scrollTrigger: {
        trigger: '.js-main-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }})
      .to('.js-main-hero-bg', {y: -100, scrollTrigger: {
        trigger: '.js-main-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }});

    $('.js-intro-block').length && tl.from('.js-intro-block-image', {y: -200, scrollTrigger: {
      trigger: '.js-intro-block',
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true
    }});

    $('.js-performance-content-wrapper').length && tl.to('.js-performance-line', {scaleY: 1, transformOrigin: 'top', scrollTrigger: {
      trigger: '.js-performance-content-wrapper',
      start: 'center bottom',
      end: 'bottom top',
      scrub: true
    }});

    $('.js-info-block').length && tl.from('.js-info-block', {y: 150, transformOrigin: 'top', scrollTrigger: {
      trigger: '.js-info-block',
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: true
    }});

    $('.js-pr-star').length && tl.to('.js-pr-star', {rotate: 360, scrollTrigger: {
      trigger: '.js-pr-star',
      start: 'top bottom',
      end: 'bottom top',
      scrub: true
    }});

    $('.js-case-image').each(function(index, item) {
      ScrollTrigger.update();
      tl.to(item, {x: 0, scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        end: 'center top',
        scrub: true,
      }});
    });

    $('.js-achievement').each(function(index, item) {
      ScrollTrigger.update();
      tl.from([item, $(item).next('.js-achievement-divider')], {opacity: 0, y: 100, scrollTrigger: {
        trigger: item,
        start: 'center bottom',
        end: 'center center',
        scrub: true,
      }});
    });
  },
  '(min-width: 720px)': () => {
    const $blocks = $('.js-schema-block');

    $('.js-schema').length && gsap.timeline({scrollTrigger: {
      trigger: '.js-schema',
      pin: true,
      start: 'center center',
      end: 'bottom+=1000px top',
      scrub: true,
    }})
      .to('.js-schema-line', {scaleY: 1, transformOrigin: 'top', duration: 0.3})
      .to('.js-schema-line', {scaleY: 0, transformOrigin: 'bottom', duration: 0.3}, 0.3)
      .to('#ellipse-main', {scale: 1.1, transformOrigin: 'center', duration: 0.3}, 0.3)
      .fromTo($blocks, {opacity: 0, pointerEvents: 'none'}, {
        pointerEvents: 'auto',
        duration: 0.3,
        opacity: 1,
        stagger: {
          each: 0.4,
          onStart() {$(this.targets()[0]).addClass('is-active');},
          onComplete() {$(this.targets()[0]).removeClass('is-active');}
        },
      })
      .to('.js-schema-line', {scaleY: -1, duration: 0.3});
  }
});

window.addEventListener('load', () => {
  ScrollTrigger.getAll().forEach(instance => {
    instance.refresh();
  });
});
